<template>
	<div class="roiWrapper">
		<div class="roiForm">
			<div class="roiFormField">
				<label for="annualPositions">{{ labelAnnualPositions }}</label>
				<input
					v-model="annualPositions"
					name="annualPositions"
					type="number"
					min="1"
					max="1000"
				/>
				<input
					v-model="annualPositions"
					name="annualPositions"
					type="range"
					min="1"
					max="1000"
				/>
			</div>
			<div class="roiFormField">
				<label for="applicantsPerPosition">{{
					labelApplicantsPerPosition
				}}</label>
				<input
					v-model="applicantsPerPosition"
					name="applicantsPerPosition"
					type="number"
				/>
				<input
					v-model="applicantsPerPosition"
					name="applicantsPerPosition"
					type="range"
					min="2"
					max="1000"
				/>
			</div>

			<div class="roiFormField">
				<label for="minutesPerApplicant">{{
					labelTimeSpentPerApplicant
				}}</label>
				<input
					v-model="minutesPerApplicant"
					name="minutesPerApplicant"
					type="number"
				/>
				<input
					v-model="minutesPerApplicant"
					name="minutesPerApplicant"
					type="range"
					min="5"
					max="500"
				/>
			</div>

			<div class="roiFormField">
				<label for="recruitersHourlySalary">{{
					labelRecruitersHourlySalary
				}}</label>
				<input
					v-model="recruitersHourlySalary"
					name="recruitersHourlySalary"
					type="number"
				/>
				<input
					v-model="recruitersHourlySalary"
					name="recruitersHourlySalary"
					type="range"
					min="10"
					max="200"
				/>
			</div>

			<div class="roiFormField">
				<label for="recruitersPerPosition">{{
					labelRecruitersPerPosition
				}}</label>
				<input
					v-model="recruitersPerPosition"
					name="recruitersPerPosition"
					type="number"
				/>
				<input
					v-model="recruitersPerPosition"
					name="recruitersPerPosition"
					type="range"
					min="1"
					max="10"
				/>
			</div>
		</div>
		<div class="roiResults">
			<div>{{ timeSaved }} {{labelTimeSaved}}</div>
			<div>{{ moneySaved }} {{labelMoneySaved}}</div>
			{{ propAnnualPositions }}
		</div>
	</div>
</template>

<script>
export default {
	name: "App",
	props: {
		labelLang: String,
		labelAnnualPositions: String,
		labelApplicantsPerPosition: String,
		labelTimeSpentPerApplicant: String,
		labelRecruitersHourlySalary: String,
		labelRecruitersPerPosition: String,
		labelTimeSaved: String,
		labelMoneySaved: String,
	},
	data() {
		return {
			annualPositions: 0,
			applicantsPerPosition: 20,
			minutesPerApplicant: 90,
			recruitersHourlySalary: 30,
			recruitersPerPosition: 2,
		};
	},
	methods: {
		calculateTimeSaved() {
			const recrightTimeSpend =
				this.annualPositions *
				this.applicantsPerPosition *
				this.recruitersPerPosition *
				5;
			const minutesSaved =
				this.annualPositions *
					this.applicantsPerPosition *
					this.minutesPerApplicant -
				recrightTimeSpend;
			return Math.round(minutesSaved / 60);
		},
		calculateMoneySaved() {
			const recrightTimeSpend =
				this.annualPositions *
				this.applicantsPerPosition *
				this.recruitersPerPosition *
				5;
			const minutesSaved =
				this.annualPositions *
					this.applicantsPerPosition *
					this.minutesPerApplicant -
				recrightTimeSpend;
			const moneySaves =
				(minutesSaved / 60) * this.recruitersHourlySalary;
			return Math.round(moneySaves);
		},
	},
	computed: {
		timeSaved() {
			return this.calculateTimeSaved();
		},
		moneySaved() {
			return this.calculateMoneySaved();
		},
	},
};
</script>

<style lang="scss">
.roiWrapper {
	text-align: center;
	max-width: 680px;
	margin: 0 auto;
	input[type="range"] {
		-webkit-appearance: none;
		margin: 18px 0;
		width: 100%;
	}
	input[type="range"]:focus {
		outline: none;
	}
	input[type="range"]::-webkit-slider-runnable-track {
		width: 100%;
		height: 8.4px;
		cursor: pointer;
		background: #f9d6d2;
		border-radius: 1.3px;
		border: 0.2px solid #d63d3f;
	}
	input[type="range"]::-webkit-slider-thumb {
		border: 0;
		height: 35px;
		width: 35px;
		border-radius: 50px;
		background: #d63d3f;
		cursor: pointer;
		-webkit-appearance: none;
		margin-top: -14px;
	}
	input[type="range"]:focus::-webkit-slider-runnable-track {
		background: #f9d6d2;
	}
	input[type="range"]::-moz-range-track {
		width: 100%;
		height: 8.4px;
		cursor: pointer;
		box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
		background: #f9d6d2;
		border-radius: 1.3px;
		border: 0.2px solid #010101;
	}
	input[type="range"]::-moz-range-thumb {
		border: 0;
		height: 35px;
		width: 35px;
		border-radius: 50px;
		background: #d63d3f;
		cursor: pointer;
	}
	input[type="number"] {
		width: 60px;
		height: 40px;
		text-align: center;
		font-size: 1.2rem;
		font-family: sans-serif;
		border-radius: 15px;
		border: 1px solid #d63d3f;
	}
	label {
		font-size: 1.2rem;
	}

	h3 {
		margin: 40px 0 0;
	}
	ul {
		list-style-type: none;
		padding: 0;
	}
	li {
		display: inline-block;
		margin: 0 10px;
	}
	a {
		color: #42b983;
	}
	.roiWrapper {
		width: 100%;
		max-width: 680px;
		margin: 0 auto;
	}
	.roiFormField {
		label {
			display: block;
		}
		input {
			margin: 0 auto;
		}
		max-width: 680px;
	}
	.roiResults {
		margin-top: 40px;
		font-size: 1.4rem;
		text-align: left;
		margin-bottom: 25px;
		border: 2px solid #d63d3f;
		padding: 20px;
		border-radius: 20px;
		text-align: center;
	}
}
</style>
